import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useSelect } from "src/hooks/form/useSelect";
import { fetchDocumentsMasters } from "src/api/shipmentExecution";

const useDocumentType = <T>(
  props: useFieldProps<T>,
  id: any,
) => {
  const field = useSelect(
    props,
    () => fetchDocumentsMasters(id),
    (data:any) => data?.documentType?.map((el) => ({ key: el.name, label: el.name })) || []
  );

  return field;
};

export default useDocumentType;
